import { render, staticRenderFns } from "./PackageList.vue?vue&type=template&id=5aef78c2&scoped=true&"
import script from "./PackageList.vue?vue&type=script&lang=js&"
export * from "./PackageList.vue?vue&type=script&lang=js&"
import style0 from "./PackageList.vue?vue&type=style&index=0&id=5aef78c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef78c2",
  null
  
)

export default component.exports